import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation, computed, input } from '@angular/core';

import { VideoService } from './video.service.js';
import { CoreComponent } from '../core/core.component.js';
import { SafeHtml } from '@angular/platform-browser';

type TypeOfVideo = 'embedded';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'lib-video',
    templateUrl: 'video.component.html',
    styleUrls: ['video.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VideoComponent extends CoreComponent {
	public readonly url = input.required<string>();
	public readonly showErrorForInvalidUrl = input<boolean>(true);

	public readonly iframeHtml: Signal<SafeHtml | undefined> = computed(() => {
		const url = this.url();

		if (!url) {
			return undefined;
		}

		return this.videoService.embed(url);
	});

	public readonly videoType: Signal<TypeOfVideo | undefined> = computed(() => {
		if (!this.url) {
			return undefined;
		}

		if (this.iframeHtml()) {
			return 'embedded';
		}

		return undefined;
	});

	constructor(private videoService: VideoService) {
		super();
	}
}
